import { render, staticRenderFns } from "./ActiveResponsibilityPicker.vue?vue&type=template&id=80fd17c8&scoped=true"
import script from "./ActiveResponsibilityPicker.vue?vue&type=script&lang=js"
export * from "./ActiveResponsibilityPicker.vue?vue&type=script&lang=js"
import style0 from "./ActiveResponsibilityPicker.vue?vue&type=style&index=0&id=80fd17c8&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../account/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "80fd17c8",
  null
  
)

export default component.exports